import { BulkAction, Dialog, Pagination, SingleAction, Sort } from "@dashboard/types";
import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const pagesSection = "/content/pages";

export const pagesListPath = pagesSection;

export type PagesListUrlDialog = "remove" | "remove-many";

export enum PagesListUrlSortField {
  title = "title",
  slug = "slug",
  created = "created",
}

export type PagesListUrlSort = Sort<PagesListUrlSortField>;
export type PagesListUrlQueryParams = BulkAction &
  Dialog<PagesListUrlDialog> &
  PagesListUrlSort &
  Pagination &
  SingleAction;

export const pagesListUrl = (params?: PagesListUrlQueryParams) =>
  pagesListPath + "?" + stringifyQs(params);

export const pageDetailsPath = (id: string) => urlJoin(pagesSection, id);

export type PageUrlDialog = "remove" | "assign-attribute-value";
export type PageUrlQueryParams = Dialog<PageUrlDialog> & SingleAction;

export const pageDetailsUrl = (id: string, params?: PageUrlQueryParams) =>
  pageDetailsPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
